import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES, VideoAssetGroupConstants } from '../../../Constants'
import { API_CONFIG, API_LIST } from '../../../Constants/ApiDefinations'
import {
  getThumbnailFromImageDetails,
  processRecordsAdvanceSearch,
} from '../../../Helpers/ManageContent'
import {
  PERMISSIONS,
  PERMISSION_TYPE,
  checkAnyMetaWritePermission,
  checkPermission,
} from '../../../Helpers/Permission'
import {
  deepClone,
  getChildList,
  getEnabledStateName,
  getOrderColumn,
  notNullUndefined,
  pollExportStatusApi,
  returnValidValue,
  setRouteToLocalStorage,
  sortListingHeaders,
} from '../../../Helpers/Util'

import { RoleConfirmationModal, TypeObject } from '../../../Models'
import mainApiService from '../../../Services'
import { useAppDispatch } from '../../../Store/Hooks'
import { showAlert } from '../../../Store/Slice/alert.slice'
import { setLoader } from '../../../Store/Slice/loader.slice'
import AssetCloneVersion from '../../AssetList/AssetCloneVersion'
import AssetImage from '../../AssetList/AssetImage'
import RoleConfirmation from '../../Dialogs/RoleConfirmation'
import HeadersColMenu from '../../HeadersColMenu/HeadersColMenu'
import AssetStateLabel from '../../Labels/AssetStateLabel'
import { MUIButton, MUICheckbox, MUIGrid } from '../../Shared'
import MUICommonTable from '../../Shared/MUI-CommonTable'
import styles from '../GlobalSearch.module.scss'

import rearrangeIcon from '../../../Assets/Images/svgs/rearrangeIcon.svg'
import { CONFIG } from '../../../Constants/Constant/Configs'
import { BLUK_PAGE_ROUTES, POLICY_PAGE_ROUTES } from '../../../Constants/ManagePolicy'
import { setSavedFilter } from '../../../Helpers/CommonListingHelper'
import { getLocalStorage, setLocalStorage } from '../../../Helpers/Storage'
import updateTagMetaData from '../../../Helpers/updateTagMetaData'
import ReorderColumnDialog from '../../Dialogs/ReorderColumnDialog'
import MUITooltip from '../../Shared/MUI-Tooltip'
import { advancedSearchConfigFunction } from './AdvancedSearchHelper'

interface AdvancedSearchListProps {
  attributes: TypeObject[]
  searchPayload: TypeObject
  searchData: Record<string, any>
  submitForm: (data: TypeObject, formData?: any, from?: any) => Promise<void>
  formData?: any
  savedFilters?: any
  mounted?: boolean
  defaultListing?: string
  bulkUpdatePath?: string
  setContentRows?: (data: any) => void
  targetedState?: any
  onCheckItems?: (data: any) => void
  checkBoxKey?: string
}

const initialFilters = {
  search: '',
  state: '',
  sort: '',
  sortType: '',
  filters: [],
  limit: 10,
  pageNumber: 1,
  content: false,
}

/**
 * Advanced Search List Component
 * @param attributes - list of all the attributes
 * @param searchPayload - payload to be send in onSubmit method for existing search
 * @param searchData - data to be shown in table for global search
 * @param submitForm - (data) => { void } function to submit the form
 * @returns {React.JSX.Element} React JSX element representing the Advanced Search List Ccomponent.
 * */

const AdvancedSearchList: React.FC<AdvancedSearchListProps> = ({
  attributes,
  searchPayload,
  searchData,
  submitForm,
  formData,
  savedFilters,
  mounted,
  defaultListing = '',
  setContentRows,
  bulkUpdatePath = '',
  targetedState = '',
  onCheckItems,
  checkBoxKey = '_id',
}: AdvancedSearchListProps) => {
  const [searchParams] = useSearchParams()
  const [reorderDilaog, setReorderDialog] = useState(false)
  const bulkCondition = returnValidValue(bulkUpdatePath, bulkUpdatePath, '/advanced-search')
  const listingPath = defaultListing ? defaultListing : bulkCondition
  const listingConfig = advancedSearchConfigFunction(listingPath)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  // const { blitzId } = useParams()
  const [dialogPropsSaveSearch, setDialogPropsSaveSearch] = React.useState<RoleConfirmationModal>({
    heading: '',
    description: '',
    color: 'primary',
    open: false,
  })
  const [rows, setRows] = useState<any>([])
  const [versionRows, setVersionRows] = useState<null | {
    index: number
    records: Record<string, any>[]
  }>(null)
  const [totalCount, setTotalCount] = useState(0)
  const [headers, setHeaders] = useState<any>([])
  const [selectedFilters, setSelectedFilters] = useState<any>({ ...initialFilters })
  const [headersColListTemp, setHeadersColListTemp] = useState<any>([])
  const [anchorHeadersColEl, setAnchorHeadersColEl] = useState<null | Element>(null)
  const [showVersionIcon, setShowVersionIcon] = useState(false)
  const [selectedVersion, setSelectedVersion] = useState<null | {
    index: number
    record: Record<string, any>
  }>(null)
  const [staticColumnOrder, setstaticColumnOrder] = useState([])
  const [isAnyMetaPermission, setIsAnyMetaPermission] = useState(true)
  const [savedFilterName, setSavedFilterName] = useState('')
  const [ispined, setIspined] = useState(false)
  const [allowPin, setAllowPin] = useState(false)
  const [pinnedErrorMessage, setpinnedErrorMessage] = useState('')
  const manageContentPermission = checkPermission(PERMISSIONS.MANAGE_CONTENT, [
    PERMISSION_TYPE.CAN_ACCESS,
  ])
  const location = useLocation()
  const [dialogProps, setDialogProps] = useState<RoleConfirmationModal>({
    heading: '',
    description: '',
    color: 'primary',
    open: false,
  })
  const [seletedItems, setSeletedItems] = useState<any>({})
  const onSaveBtnClick = () => {
    getPinnedSearch()
    setDialogPropsSaveSearch({
      heading: CONSTANTS.SAVE_SEARCH_TITLE,
      color: 'primary',
      Icon: 'Pinned',
      open: true,
      iconColor: 'success',
      successButtonLabel: 'Submit',
      cancelButtonLabel: 'Cancel',
    })
  }
  const [exportStatus, setExportStatus] = useState('') // Add state for export status
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null) // Ref to manage the timeout ID
  const getPinnedSearch = async () => {
    let requestedData: any = API_CONFIG(API_LIST.PINNED_SEARCH.COUNT)
    if (localStorage.getItem('isRecentPinAction') === 'yes') {
      requestedData = API_CONFIG(API_LIST.PINNED_SEARCH.COUNT, null, null, null, {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      })
    }

    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200 && result?.data) {
      localStorage.setItem('isRecentPinAction', 'no');
      setAllowPin(result.data.length < 6);
    } else {
      setAllowPin(true);
    }
  }

  const headOrder = getLocalStorage(CONSTANTS.LOCAL_KEYS.LISTING_ORDER)
  const userData = getLocalStorage(CONSTANTS.LOCAL_KEYS.USER_DATA)

  const getHeadersOrder = async () => {
    const requiredApiData = API_CONFIG(API_LIST.USER_CONFIG.GET, null, {
      userId: userData.userId,
    })
    dispatch(setLoader(true))
    const result = await mainApiService(requiredApiData)
    if (result?.responseCode === 200) {
      setLocalStorage(CONSTANTS.LOCAL_KEYS.LISTING_ORDER, result.data)
    } else {
      dispatch(showAlert([true, result?.error?.message, 'error']))
    }
    dispatch(setLoader(false))
  }

  const onReorderColumn = async (data: TypeObject[], columnList?: any) => {
    const tempStaticCol: any = []
    data?.forEach((ele: any) => {
      tempStaticCol.push(ele.id)
    })
    setstaticColumnOrder(tempStaticCol)
    const tempArrangeColumn: any = []
    data.forEach((item) => {
      const columnId = item.id
      tempArrangeColumn.push(columnId)
    })
    const payload = {
      userId: userData.userId,
      configuration: {
        ['AdvanceSearch']: tempArrangeColumn || [],
      } as Record<string, any>,
    }
    const requiredApiData = API_CONFIG(API_LIST.USER_CONFIG.UPDATE, payload, {
      userId: userData.userId,
    })
    dispatch(setLoader(true))
    const result = await mainApiService(requiredApiData)
    if (result?.responseCode === 200) {
      const finalHeader = getOrderColumn(columnList || headers, tempArrangeColumn || [])
      setHeaders(finalHeader)
      getHeadersOrder()
      dispatch(showAlert([true, 'Listing view modified successfully', 'success']))
    } else {
      dispatch(showAlert([true, result?.error?.message, 'error']))
    }
    dispatch(setLoader(false))
  }

  // useEffect(() => {
  //   getHeadersOrder()
  // }, [])

  useEffect(() => {
    getExportSearchList()
    if (!bulkUpdatePath) {
      updateTagMetaData({ title: 'Search' })
    }
    setIsAnyMetaPermission(checkAnyMetaWritePermission())
    return () => {
      updateTagMetaData({})
      // Cleanup function to clear the timeout when the component is unmounted
      if (notNullUndefined(timeoutIdRef.current)) {
        clearTimeout(timeoutIdRef.current as any)
      }
    }
  }, [])

  useEffect(() => {
    if (onCheckItems) onCheckItems(Object.values(seletedItems).flat())
  }, [seletedItems])

  useEffect(() => {
    setSavedFilter(listingConfig?.pageKey, {
      filterData: deepClone(searchPayload),
      formData: deepClone({ ...formData }),
      headers: deepClone(headers),
    })
  }, [headers])

  useEffect(() => {
    if (attributes.length) {
      getListingHeaders()
    }
  }, [attributes, formData])
  // useEffect(() => {
  //   getListingHeaders()
  // }, [headOrder])
  useEffect(() => {
    if (savedFilters?.filterData && searchParams.get('filter')) {
      const selectedFiltersCopy = {
        search: '',
        state: '',
        sort: savedFilters?.filterData?.sort?.[0]?.sortBy ?? '',
        sortType: savedFilters?.filterData?.sort?.[0]?.sortType ?? 1,
        filters: [],
        limit: savedFilters?.filterData?.limit ?? 10,
        pageNumber: savedFilters?.filterData?.page ?? 1,
        content: savedFilters?.filterData?.sort?.[0]?.sortIn === 'content' ? true : false,
      }
      setSelectedFilters({ ...selectedFiltersCopy })
    }
  }, [savedFilters])

  useEffect(() => {
    getListingData('search', { ...selectedFilters })
  }, [searchData])

  useEffect(() => {
    if (selectedVersion && selectedVersion.index >= 0) {
      if (versionRows && versionRows.index === selectedVersion.index) {
        setVersionRows(null)
        setSelectedVersion(null)
      } else {
        getNestedVersionList(selectedVersion.record, selectedVersion.index)
      }
    }
  }, [selectedVersion])

  useEffect(() => {
    setContentRows && setContentRows(rows)
  }, [rows])

  /**
   * To generate asset url
   * @function generateContentURL
   * @param {string} _id - id of asset
   * @param {string} assetType - assetType of asset
   * @param {string} contentCategory - contentCategory of asset
   * @param {string} assetCategory - asset category of asset
   * @returns {string}
   */
  const generateContentURL = (
    _id: string,
    assetType: string,
    contentCategory: string,
    assetCategory: string,
  ): string => {
    if (!_id || !assetType || !assetCategory) {
      return ''
    }
    return `/asset/view/${_id}/${assetType}/${contentCategory}/${assetCategory}/${CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY}`
  }

  /**
   * To generate header based on the attributes data provided in search data mapping it with attributes list.
   * @function getListingHeaders
   * @returns {void}
   */
  const getListingHeaders = () => {
    const { records = [] } = searchData
    const existingHeaders = headers
      .filter(
        (item: { content: boolean; viewInListing: boolean }) => !item.content && item.viewInListing,
      )
      .map((head: { id: string }) => ({ filterBy: head.id }))
    const searchedAttributes = searchPayload?.attributeFilters ?? []
    const assetGroupAttributes = searchPayload?.assetGroupFilters ?? []
    const attributesToAddInTable: any = [
      ...existingHeaders,
      ...searchedAttributes,
      ...assetGroupAttributes,
    ]
    if (attributes.length) {
      const headersObj: any = {}
      processRecordsAdvanceSearch(
        records,
        attributes?.filter((item: TypeObject) => item?.fieldName !== 'firstCreatedOn'),
        headersObj,
        attributesToAddInTable,
        true,
      )
      const defaultListingColumn = listingConfig.listingColumns

      let headersArray: any = [
        ...JSON.parse(JSON.stringify(defaultListingColumn)),
        ...Object.values(headersObj),
      ]
      headersArray = sortListingHeaders(headersArray)

      if (savedFilters?.headers?.length && searchParams.get('filter') && mounted) {
        setHeaders(savedFilters.headers)
      } else if ((location?.state?.id || searchParams.get(',id')) && searchPayload?.headers) {
        setHeaders(getOrderColumn(headersArray, searchPayload?.headers || []))
      } else {
        setHeaders(
          getOrderColumn(
            headersArray,
            POLICY_PAGE_ROUTES.includes(defaultListing) || BLUK_PAGE_ROUTES.includes(bulkUpdatePath)
              ? staticColumnOrder
              : (headOrder && headOrder['AdvanceSearch']) || [],
          ),
        )
      }
    }
  }

  /**
   * To process the search data to be shown in a table
   * @function handleListingDataForTable
   * @param {string} records - search data in the form of array of objects
   * @param {boolean} isChild - is the child listing for child
   * @returns {array}
   */
  const handleListingDataForTable = (records: any, isChild = false) => {
    const rowData: any = []
    let isVersionIconTemp = false
    if (!isChild) {
      // records[0].versionCount = 2 // For demo puprpose
      records.forEach((record: any) => {
        if (record.versionCount > 1) {
          isVersionIconTemp = true
        }
      })
      setShowVersionIcon(isVersionIconTemp)
    }

    const enabledState = getEnabledStateName(targetedState)

    records.map((record: Record<string, any>, index: number) => {
      let isCheckBoxDisabled = false
      if (bulkUpdatePath === 'interactive-bulk-update') {
        isCheckBoxDisabled = isChild
      } else if (bulkUpdatePath === 'bulk-state-change') {
        isCheckBoxDisabled = record.state !== enabledState
      }

      const recordCopy: Record<string, any> = {
        ...record,
        isCheckBoxDisabled,
        isBaseAsset: record.isBaseAsset,
        contentId: record.contentId,
        updatedAt: record.updatedAt,
        image: <AssetImage imageUrl={''} />,
        state: <AssetStateLabel state={record.state} />,
        versionCloneCount: (
          <AssetCloneVersion
            showClone={false}
            isVersionIcon={isVersionIconTemp}
            isChild={isChild}
            index={index}
            assetDetails={record}
            onClickAssetVersion={(record: Record<string, any>, index: number) =>
              setSelectedVersion({ record, index })
            }
            isAnyMetaPermission={isAnyMetaPermission}
            onClickClone={() => {
              return
            }}
          />
        ),
      }
      if (record?.metaAttributes?.landscapeThumb?.length) {
        recordCopy.image = (
          <AssetImage imageUrl={getThumbnailFromImageDetails(record?.metaAttributes)} />
        )
      }
      recordCopy['rowURL'] = manageContentPermission
        ? generateContentURL(
            record._id,
            record.assetType,
            record.contentCategory,
            record.assetCategory,
          )
        : `${location.pathname}${PAGES_ROUTES?.AccessDenied}${location.search}`
      delete recordCopy.ContentMetaCategory
      if (record?.mediaInfo?.subtitleLanguageFiles?.length) {
        recordCopy.metaAttributes = {
          ...recordCopy.metaAttributes,
          subtitleLanguageFiles: record?.mediaInfo?.subtitleLanguageFiles,
        }
      }
      if (record?.assetGroup?.assetGroupName?.length) {
        recordCopy.metaAttributes = {
          ...recordCopy.metaAttributes,
          assetGroupName: record?.assetGroup?.assetGroupName,
        }
      }
      if (record?.assetGroup?.mediaProfile?.length) {
        recordCopy.metaAttributes = {
          ...recordCopy.metaAttributes,
          mediaProfile: record?.assetGroup?.mediaProfile,
        }
      }
      if (record?.assetGroup?.assetType?.length) {
        recordCopy.metaAttributes = {
          ...recordCopy.metaAttributes,
          assetType: record?.assetGroup?.assetType,
        }
      }
      if (record?.assetGroup?.assetGroupId) {
        recordCopy.metaAttributes = {
          ...recordCopy.metaAttributes,
          assetGroupId: record?.assetGroup?.assetGroupId,
        }
      }
      rowData.push(recordCopy)
    })
    return rowData
  }

  /**
   * To prepare the listing for table and calls the submit method in case of sorting and page change
   * @function getListingData
   * @param {string} type - filter / search based on this it will call sort and page change or search form data
   * @returns {void}
   */
  const getListingData = async (type: string, selectedFilterArgs: any) => {
    const payload: any = {
      ...searchPayload,
      page: selectedFilterArgs?.pageNumber ?? initialFilters.pageNumber,
      limit: selectedFilterArgs?.limit ?? initialFilters.limit,
    }
    let sortInCategory = 'attribute'
    if (selectedFilterArgs?.content) {
      sortInCategory = 'content'
    } else if (
      ['assetGroupName', 'mediaProfile', 'assetType', 'assetGroupId'].includes(
        selectedFilterArgs?.sort,
      )
    ) {
      sortInCategory = 'assetGroup'
    } else if (['isBaseAsset'].includes(selectedFilterArgs?.sort)) {
      sortInCategory = 'content'
    }

    payload.sort = selectedFilterArgs?.sort?.length
      ? [
          {
            sortBy: selectedFilterArgs?.sort,
            sortType: +selectedFilterArgs?.sortType,
            sortIn: sortInCategory,
          },
        ]
      : []

    if (type === 'filter') await submitForm(payload, false)

    setVersionRows(null)
    const { records = [], count = 0 } = searchData
    setTotalCount(count)
    const rowData: Record<string, any>[] = handleListingDataForTable(records)
    setRows(rowData)
    getListingHeaders()
  }

  /**
   * To handle page change of table
   * @function handlePageChange
   * @param {number} pageNumber - current page of table
   * @returns {void}
   */
  const handlePageChange = (pageNumber: any) => {
    const selectedFiltersCopy = { ...selectedFilters, pageNumber }
    setSelectedFilters(selectedFiltersCopy)
    getListingData('filter', selectedFiltersCopy)
  }

  /**
   * To handle page count change of table
   * @function handlePageCountChange
   * @param {number} limit - page count no of items to be shown in table
   * @returns {void}
   */
  const handlePageCountChange = (limit: any) => {
    const selectedFiltersCopy = { ...selectedFilters, pageNumber: 1, limit }
    setSelectedFilters(selectedFiltersCopy)
    getListingData('filter', selectedFiltersCopy)
    handleChekBoxChange([], true)
  }

  /**
   * To handle page count change of table
   * @function handleSortChange
   * @param {number} limit - page count no of items to be shown in table
   * @returns {void}
   */
  const handleSortChange = (header: Record<string, any>, sortType: number) => {
    const selectedFiltersCopy = {
      ...selectedFilters,
      pageNumber: 1,
      sort: header.fieldName,
      sortType: String(sortType),
      content: header.content,
    }
    setSelectedFilters(selectedFiltersCopy)
    getListingData('filter', selectedFiltersCopy)
    handleChekBoxChange([], true)
  }
  const clearSortFilters = () => {
    const newFilters: any = {
      ...selectedFilters,
      sort: '',
      sortType: '',
      pageNumber: 1,
    }
    setSelectedFilters(newFilters)
    getListingData('filter', newFilters)
    handleChekBoxChange([], true)
  }

  /**
   * To handle checkbox change in table
   * @function handleChekBoxChange
   * @param {array} items - selected rows of table
   * @param {boolean} clearAll - if all rows are selected
   * @returns {void}
   */
  const handleChekBoxChange = (items: any, clearAll = false) => {
    setSeletedItems((prev: any) => {
      const updatedItems = clearAll ? {} : { ...prev, [selectedFilters.pageNumber]: items }
      return updatedItems
    })
  }

  /**
   * To navigate to asset details page.
   * @function handleOpenAsset
   * @param {string} rowDetails - row details of table which may have _id, assetType, assetCategory, contentCategory,
   * @returns {void}
   */
  const handleOpenAsset = (rowDetails: Record<string, any>) => {
    const dt = rowDetails.row
    setRouteToLocalStorage(`${location.pathname}${location.search}`)
    if (!manageContentPermission) {
      navigate(`${location.pathname}${PAGES_ROUTES?.AccessDenied}${location.search}`)
      return
    }
    navigate(
      `/asset/view/${dt._id}/${dt.assetType}/${dt.contentCategory}/${dt.assetCategory}/${CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY}`,
    )
  }

  /**
   * To get the data for child asset
   * @function handleListingDataForTable
   * @param {string} record - single record of search from table
   * @param {boolean} index - index of particular row from table
   * @returns {void}
   */
  const getNestedVersionList = async (record: Record<string, any>, index: number) => {
    setVersionRows(null)
    dispatch(setLoader(true))
    const payload: any = {
      ...searchPayload,
      page: selectedFilters.pageNumber,
      limit: selectedFilters.limit,
    }

    if (selectedFilters.sort) {
      payload.sort = [
        {
          sortBy: selectedFilters.sort,
          sortType: Number(selectedFilters.sortType),
          sortIn: selectedFilters?.content ? 'content' : 'attribute',
        },
      ]
    }

    payload.blitzId = record.blitzId.toString()

    const requestedParams = API_CONFIG(API_LIST.GLOBAL_SEARCH.NESTED_LIST, payload)
    const controller = new AbortController()

    const apiRes: any = await mainApiService({ ...requestedParams, signal: controller.signal })
    dispatch(setLoader(false))

    if (Array.isArray(apiRes?.data)) {
      const childData = getChildList(apiRes?.data, record)
      if (childData?.length) {
        setVersionRows({
          index,
          records: handleListingDataForTable(childData, true),
        })
      }
    }
  }
  const handleCloseSaveSearch = () => {
    setDialogPropsSaveSearch({
      heading: '',
      description: '',
      color: 'primary',
      open: false,
    })
    setSavedFilterName('')
    setAllowPin(true)
    setIspined(false)
    setpinnedErrorMessage('')
  }

  // Function to generate selectAttributes object
  const generateSelectAttributes = (headers: any) => {
    return headers
      .filter((header: any) => header.viewInListing)
      .reduce((acc: any, header: any) => {
        if (header.fieldName === 'image') {
          acc['landscapeThumb'] = true
        } else if (
          header?.fieldName === 'assetType' &&
          header?.id === 'metaAttributes.assetType' &&
          header?.label === 'Transcoding Process Type'
        ) {
          acc['transCodingProcessType'] = true
        } else if (header?.fieldName?.split('.')?.length > 1) {
          const imageFieldName = header?.fieldName?.split('.')[0]
          acc[imageFieldName] = true
        } else {
          acc[header.fieldName] = true
        }
        return acc
      }, {})
  }

  const handleExport = async (initialSearchPayload: TypeObject) => {
    dispatch(setLoader(true))
    try {
      // Use the function to get the selectAttributes object
      const selectAttributes = generateSelectAttributes(headers)
      const { ...filteredSelectAttributes } = selectAttributes
      // Modify the searchPayload
      const { ...restPayload } = initialSearchPayload
      const modifiedSearchPayload = {
        ...restPayload,
        page: 1,
        selectAttributes: filteredSelectAttributes,
      }
      const reqPayload = API_CONFIG(API_LIST.GLOBAL_SEARCH.EXPORT_ADD, modifiedSearchPayload)
      const result: any = await mainApiService(reqPayload)

      if (result?.error?.responseCode === 400) {
        setDialogProps({
          heading: CONSTANTS?.LIMIT_EXCEED,
          description: CONSTANTS?.LIMIT_EXCEED_CONTENT,
          color: 'error',
          Icon: 'ExportLimitCloseIcon',
          open: true,
          iconColor: 'error',
          successButtonLabel: 'Okay',
          handleSuccess: handleClose,
        })
        return
      } else if (result?.error) {
        dispatch(showAlert([true, result?.error?.message, 'error']))
        dispatch(setLoader(false))
        return
      }

      if (result?.responseCode === 200) {
        const status = result?.data?.exportStatus
        const exportId = result?.data?._id
        setExportStatus(status)
        if (status === 'IN_PROGRESS') {
          pollExportStatus(exportId, dispatch)
        } else if (status === 'SUCCESS') {
          setExportStatus('SUCCESS')
        } else {
          console.error('Unexpected export status', result?.data)
        }
      } else {
        dispatch(showAlert([true, 'Unexpected response from the server', 'error']))
      }
    } catch (error) {
      dispatch(showAlert([true, 'Error initiating export', 'error']))
    } finally {
      dispatch(setLoader(false))
    }
  }

  const pollExportStatus = async (exportId: any, dispatch: any) => {
    const clearPolling = () => {
      if (notNullUndefined(timeoutIdRef.current)) {
        clearTimeout(timeoutIdRef.current as any)
      }
    }

    const clearPollingWithMessage = (message: string, type: 'success' | 'error') => {
      dispatch(showAlert([true, message, type]))
      clearPolling()
    }

    const setLongPullTimeout = () => {
      timeoutIdRef.current = setTimeout(poll, CONFIG.EXPORT_POLLING_INTERVAL)
    }

    const poll = async () => {
      try {
        const result = await pollExportStatusApi(exportId)

        if (result?.error) {
          clearPollingWithMessage(result?.error?.message, 'error')
          return
        }

        if (result?.responseCode !== 200) {
          clearPollingWithMessage('Unexpected response from the server', 'error')
          return
        }

        const status = result?.data?.[0]?.exportStatus
        setExportStatus(status)

        switch (status) {
          case 'SUCCESS':
            clearPollingWithMessage('Export successful!', 'success')
            break

          case 'IN_PROGRESS':
            setLongPullTimeout()
            break

          default:
            clearPollingWithMessage('Export failed', 'error')
        }
      } catch {
        clearPollingWithMessage('Error polling export status', 'error')
      }
    }

    setLongPullTimeout()
  }

  const getExportSearchList = async () => {
    const reqData = API_CONFIG(API_LIST.GLOBAL_SEARCH.EXPORT_LIST)
    const result = await mainApiService(reqData)
    setExportStatus(result?.data && result?.data[0]?.exportStatus)
  }

  const savePinSearchSubmit = async (searchPayload: any) => {
    const { ...restPayload } = searchPayload
    const selectedColumns = headers
      .filter((item: any) => item.viewInListing)
      .map((item: any) => item.id)
    restPayload.headers = selectedColumns
    const saveSearchPayload = {
      payload: restPayload,
      name: savedFilterName,
      isPinnedToDashboard: ispined,
    }

    const requestedPayload = API_CONFIG(API_LIST.ADVANCED_SEARCH.SAVE_SEARCH, saveSearchPayload)
    const result = await mainApiService(requestedPayload)
    if (result.data) {
      handleCloseSaveSearch()
      setSavedFilterName('')
      setIspined(false)
      setpinnedErrorMessage('')
      localStorage.setItem('isRecentPinAction', 'yes')
    } else {
      if (result?.error?.blitzCode === 'BLITZ_22011') {
        setpinnedErrorMessage(result?.error?.message)
      } else {
        dispatch(showAlert([true, result?.error?.message, 'error']))
      }
    }
  }

  const handleClose = () => {
    setDialogProps({
      heading: '',
      description: '',
      color: 'error',
      open: false,
    })
  }
  const bulkUpdateCSS = bulkUpdatePath ? '' : 'wrapper pl-2 pr-2'
  return (
    <>
      <ReorderColumnDialog
        headers={headers?.filter((item: any) => item.viewInListing)}
        open={reorderDilaog}
        onSubmit={onReorderColumn}
        handleClose={() => setReorderDialog(false)}
      />
      <div
        className={` ${defaultListing?.length ? 'wrapper' : bulkUpdateCSS} pb-1 `}
        id='advanced_search_list'
      >
        <MUIGrid
          className='interFont'
          style={{
            width: '100%',
            backgroundColor: '#f5f4f4',
          }}
        >
          <MUIGrid
            container
            className='d-flex mb-1 gap-2 justify-content-end align-items-center listing-filter'
          >
            {rows && rows.length > 0 && (
              <>
                <div>
                  <MUITooltip
                    disableInteractive={true}
                    title={exportStatus === 'IN_PROGRESS' && 'Previous download is in progress'}
                    placement='top'
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          padding: '1rem',
                          fontSize: '12px',
                          fontWeight: '500',
                          color: '#402080',
                          bgcolor: '#ECE9F2',
                          '& .MuiTooltip-arrow': {
                            color: '#ECE9F2',
                          },
                          display: `${exportStatus === 'IN_PROGRESS' ? 'block' : ' none'}`,
                        },
                      },
                    }}
                  >
                    <div>
                      {!defaultListing?.length && !bulkUpdatePath?.length ? (
                        <MUIButton
                          className={styles.exportBtn}
                          variant={'outlined'}
                          label={'Export'}
                          type='button'
                          handleClickCB={() => handleExport(searchPayload)}
                          fontWeight={500}
                          disabled={exportStatus === 'IN_PROGRESS'} // Disable button while export is in progress
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </MUITooltip>
                </div>
              </>
            )}
            <div
              className='bg-col70 d-flex align-items-center cursor-pointer'
              style={{
                height: '40px',
                padding: '0 12px 0 12px',
                borderRadius: '6px',
                border: '1px solid #B1B4B6',
                textAlign: 'end',
              }}
              data-testid='list_add_column-test'
              onClick={(event: any) => {
                if (headers?.length) {
                  const tempList = headers?.length ? JSON.parse(JSON.stringify(headers)) : []
                  setHeadersColListTemp(
                    tempList.map((item: any) => ({ ...item, select: item.viewInListing })),
                  )
                  setAnchorHeadersColEl(event.currentTarget)
                }
              }}
            >
              <span style={{ fontSize: '14px' }}>Add Column</span>
              <span>
                {anchorHeadersColEl ? (
                  <KeyboardArrowUp sx={{ marginTop: '10px', color: '#8E9092' }} />
                ) : (
                  <KeyboardArrowDown sx={{ marginTop: '10px', color: '#8E9092' }} />
                )}
              </span>
            </div>

            {anchorHeadersColEl && (
              <HeadersColMenu
                headers={headers}
                anchorEl={anchorHeadersColEl as any}
                open={true}
                search='Search Attibute'
                onClose={() => {
                  setAnchorHeadersColEl(null)
                }}
                clear
                headersColListTemp={headersColListTemp}
                setHeadersColListTemp={setHeadersColListTemp}
                setHeadersColList={(tempList) => {
                  if (tempList.length) {
                    const selectedHeadersCopy = tempList.map((item: any) => ({
                      ...item,
                      viewInListing: item.select,
                    }))
                    const columnHeader = selectedHeadersCopy.filter(
                      (item: any) => item.viewInListing,
                    )
                    onReorderColumn(columnHeader, selectedHeadersCopy)
                  } else {
                    setHeadersColListTemp([])
                  }
                }}
                showLoaderFn={(action: boolean) => {
                  dispatch(setLoader(action))
                }}
                columnDefaultOrder={headers}
              />
            )}
          </MUIGrid>

          <MUICommonTable
            headers={[
              {
                id: 'versionCloneCount',
                fieldName: 'versionCloneCount',
                label: '',
                sort: false,
                icon: (
                  <MUITooltip title='Rearrange Columns' arrow disableInteractive={true}>
                    {!defaultListing?.length && !bulkUpdatePath?.length ? (
                      <span
                        className='d-flex justify-content-center align-items-center cursor-pointer'
                        onClick={() => setReorderDialog(true)}
                        data-testId='reOrderDragIcon'
                      >
                        <img src={rearrangeIcon} />
                      </span>
                    ) : (
                      <></>
                    )}
                  </MUITooltip>
                ),

                class: showVersionIcon ? 'list_version_icon' : 'rearrange_icon',
              },

              ...headers.filter((item: any) => item.viewInListing),
            ]}
            rows={rows}
            childRows={versionRows}
            sortFilterKey={'fieldName'}
            selectedFilters={selectedFilters}
            onChangeSort={handleSortChange}
            onClearSortFilters={clearSortFilters}
            onClickRow={handleOpenAsset}
            checkboxTooltip={{ row: 'Select Row', header: 'Select All' }}
            pagination={{
              show: true,
              pageLimit: selectedFilters.limit,
              pageNumber: selectedFilters.pageNumber,
              totalCount: totalCount,
              onPageChange: handlePageChange,
              onPageCountChange: handlePageCountChange,
              limitOptions: bulkUpdatePath
                ? [...CONFIG.LISTING_LIMIT_OPTIONS_HUNDRADE]
                : [...CONFIG.LISTING_LIMIT_OPTIONS],
            }}
            enableCheckbox={bulkUpdatePath?.length ? true : false}
            checkBoxKey={checkBoxKey}
            checkedItems={seletedItems[selectedFilters.pageNumber] || []}
            onCheckItems={handleChekBoxChange}
          />
        </MUIGrid>
        <div className='mt-15 d-flex justify-content-end'>
          {!defaultListing?.length && !bulkUpdatePath?.length ? (
            <MUIButton
              size='large'
              type={'button'}
              label={'Save & Pin'}
              data-testid='submit-btn-search'
              variant='contained'
              // width={250}
              className='save-btn interfont'
              handleClickCB={onSaveBtnClick}
            />
          ) : (
            <></>
          )}
        </div>
        <RoleConfirmation
          handleSuccess={() => {
            savePinSearchSubmit(searchPayload)
          }}
          description={
            <div>
              <div className='mt-1'>
                <TextField
                  label={
                    <span>
                      Name
                      <>
                        <span className='col37'>*</span>
                      </>
                    </span>
                  }
                  onChange={(evt: any) => {
                    if (savedFilterName.length < 25) {
                      setSavedFilterName(evt.target.value)
                    } else {
                      setSavedFilterName(evt.target.value.slice(0, 25))
                    }
                  }}
                  onPaste={(e: any) => {
                    setSavedFilterName(e.clipboardData.getData('text').slice(0, 25))
                  }}
                  value={savedFilterName}
                  name='search_name'
                  helperText={pinnedErrorMessage}
                  error={Boolean(pinnedErrorMessage.length)}
                  fullWidth
                  inputProps={{ 'data-testid': 'activationCode' }}
                />
              </div>
              <div className='mt-1 d-flex justify-content-between allign-items-center'>
                {allowPin ? (
                  <MUICheckbox
                    label={'Pin to Homepage'}
                    checked={ispined}
                    labelClass='ml-1 paragraph-regular-6 col36'
                    handleChange={() => {
                      setIspined((prevState) => !prevState)
                    }}
                  />
                ) : (
                  <div className='d-flex '>
                    <MUITooltip
                      title={
                        'Maximum pin limit reached. Please unpin any result to pin the current one.'
                      }
                      placement='top-start'
                      arrow
                      componentsProps={VideoAssetGroupConstants.SAVE_SEARCH_TOOLTIP_CSS}
                      disableInteractive={true}
                    >
                      <CheckBoxOutlineBlankIcon sx={{ color: '#B1B4B6' }} />
                    </MUITooltip>
                    <span className='ml-1'>Pin to Homepage</span>
                  </div>
                )}
                <p>{savedFilterName?.length}/25</p>
              </div>
            </div>
          }
          minWidth='778px'
          {...dialogPropsSaveSearch}
          handleClose={handleCloseSaveSearch}
        />
        <RoleConfirmation {...dialogProps} handleClose={handleClose} />
      </div>
    </>
  )
}

export default AdvancedSearchList
